export default "__VITE_ASSET__DCnt7APY__"